export default "__VITE_ASSET__KpjoznlM__"